import React, { useEffect, useState } from "react";
import axios from "axios";
import { t } from "../../../lang/index";

const CompanyRegisterModal = () => {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [form, setForm] = useState({
    email: "",
    nome: "",
    nif: "",
    telefone: "",
    rua: "",
    cidade: "",
    codigoPostal: "",
    pais: "",
    descricao: "",
    nib: "",
    numeroCertidaoPermanente: "",
    servicosIds: [] as number[], // <-- IDs dos serviços
  });

  const [method, setMethod] = useState<"test" | "email" | null>(null);


  const [servicos, setServicos] = useState<{ id: number; nome: string; emoji?: string }[]>([]);

  useEffect(() => {
    const fetchServicos = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/servicos`);
        setServicos(response.data);
      } catch (err) {
        console.error("Erro ao buscar serviços", err);
      }
    };

    fetchServicos();
  }, []);

  const BASE_URL = process.env.REACT_APP_API_URL;

  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const closeModal = () => {
    const modal = document.getElementById("company-register-modal");
    let bootstrapModal = (window as any).bootstrap?.Modal.getInstance(modal);
    if (!bootstrapModal) {
      bootstrapModal = new (window as any).bootstrap.Modal(modal);
    }
    bootstrapModal.hide();
    setTimeout(() => {
      document.querySelectorAll(".modal-backdrop").forEach((el) => el.remove());
      document.body.classList.remove("modal-open");
    }, 300);
  };

  const sendCode = async () => {
    try {
      await axios.post(`${BASE_URL}/teste/gerar-codigo-manual`, null, {
        params: { email, codigo: "123456" },
      });
      setMessage("Code sent successfully. Use '123456' for testing.");
      setError("");
      setStep(2);
    } catch {
      setError("Failed to send the verification code.");
      setMessage("");
    }
  };

  const sendCodeEmail = async () => {
    try {
      await axios.post(`${BASE_URL}/auth/enviar-codigo`, { email });
      setMessage("Verification email sent successfully.");
      setError("");
      setStep(2);
    } catch {
      setError("Failed to send verification email.");
      setMessage("");
    }
  };


  const verifyCode = async () => {
    try {
      const response = await axios.post(`${BASE_URL}/auth/verificar-codigo`, {
        email,
        codigo: code,
      });
      const token = response.data.token;
      localStorage.setItem("token", token);
      setMessage("Verification successful.");
      setError("");
      setStep(3);
    } catch {
      setError("Invalid or expired code.");
      setMessage("");
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const [aceitouContrato, setAceitouContrato] = useState(false);

  const handleFinalSubmit = async () => {
    // Validar campos obrigatórios
    if (!form.nome || !form.nif || !form.nib || !form.numeroCertidaoPermanente) {
      setError("Please fill all required fields.");
      return;
    }

    // Validar aceite do contrato
    if (!aceitouContrato) {
      setError("You must accept the contract to register the company.");
      return;
    }

    try {
      const token = localStorage.getItem("token");
      if (!token) {
        setError("You must be logged in to register the company.");
        return;
      }

      // 1️⃣ Criar empresa
      const empresaResp = await axios.post(`${BASE_URL}/empresas`, form, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const empresaId = empresaResp.data.id;

      // 2️⃣ Registrar aceite do contrato
      const dto = {
        versaoContrato: "v1.0",
        userAgent: navigator.userAgent,
      };
      await axios.post(`${BASE_URL}/empresas/${empresaId}/contrato-aceite`, dto, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setMessage("Company registered and contract accepted successfully!");
      closeModal();
    } catch (err: any) {
      console.error(err);
      setError(err.response?.data?.message || "Failed to register the company or accept the contract.");
    }
  };

  const handleCheckboxChange = (servicoId: number) => {
    setForm((prev) => {
      const jaSelecionado = prev.servicosIds.includes(servicoId);
      return {
        ...prev,
        servicosIds: jaSelecionado
          ? prev.servicosIds.filter((id) => id !== servicoId)
          : [...prev.servicosIds, servicoId],
      };
    });
  };

  return (
    <div className="modal fade" id="company-register-modal" tabIndex={-1}>
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content">
          <div className="modal-header d-flex align-items-center justify-content-end pb-0 border-0">
            <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
          </div>
          <div className="modal-body p-4 pt-0">
            <form onSubmit={(e) => e.preventDefault()}>
              <div className="text-center border-bottom mb-4">
                <h5 className="mb-1">{t("companyRegisterModal.title")}</h5>
                <p className="mb-3">
                  {step === 1 && t("companyRegisterModal.step1")}
                  {step === 2 && t("companyRegisterModal.step2")}
                  {step === 3 && t("companyRegisterModal.step3")}
                </p>
              </div>

              {step === 1 && (
                <>
                  <input
                    name="email"
                    type="email"
                    className="form-control mb-2"
                    placeholder={t("companyRegisterModal.personalEmail")}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <button
                    type="button"
                    className="btn btn-secondary w-100 mt-2"
                    onClick={() => { sendCode(); setMethod("test"); }}
                  >
                    {t("companyRegisterModal.sendTestCode")}
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary w-100 mt-2"
                    onClick={() => { sendCodeEmail(); setMethod("email"); }}
                  >
                    {t("companyRegisterModal.sendEmailCode")}
                  </button>
                </>
              )}

              {step === 2 && (
                <>
                  <input
                    name="code"
                    type="text"
                    className="form-control mb-2"
                    placeholder={t("companyRegisterModal.verificationCode")}
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                  />
                  <button
                    type="button"
                    className="btn btn-success w-100 mt-2"
                    onClick={verifyCode}
                  >
                    {t("companyRegisterModal.verifyCode")}
                  </button>
                </>
              )}

              {step === 3 && (
                <div className="row g-3">
                  {[
                    { name: "email", placeholder: t("companyRegisterModal.companyEmail"), type: "email", col: "col-md-6" },
                    { name: "nome", placeholder: t("companyRegisterModal.companyName"), type: "text", col: "col-md-6" },
                    { name: "nif", placeholder: t("companyRegisterModal.nif"), type: "text", col: "col-md-6" },
                    { name: "nib", placeholder: t("companyRegisterModal.nib"), type: "text", col: "col-md-6" },
                    { name: "numeroCertidaoPermanente", placeholder: t("companyRegisterModal.permanentCertificate"), type: "text", col: "col-md-6" },
                    { name: "telefone", placeholder: t("companyRegisterModal.phone"), type: "text", col: "col-md-6" },
                    { name: "rua", placeholder: t("companyRegisterModal.street"), type: "text", col: "col-12" },
                    { name: "cidade", placeholder: t("companyRegisterModal.city"), type: "text", col: "col-md-6" },
                    { name: "codigoPostal", placeholder: t("companyRegisterModal.postalCode"), type: "text", col: "col-md-3" },
                    { name: "pais", placeholder: t("companyRegisterModal.country"), type: "text", col: "col-md-3" },
                  ].map((field) => (
                    <div key={field.name} className={field.col}>
                      <input
                        name={field.name}
                        type={field.type}
                        className="form-control"
                        placeholder={field.placeholder}
                        onChange={handleChange}
                      />
                    </div>
                  ))}

                  <div className="col-12">
                    <textarea
                      name="descricao"
                      className="form-control"
                      placeholder={t("companyRegisterModal.companyDescription")}
                      rows={3}
                      onChange={handleChange}
                    />

                  </div>

                  <div className="col-12">
                    <label className="form-label">{t("companyRegisterModal.servicesProvided")}</label>
                    <div className="form-check d-flex flex-wrap gap-3">
                      {servicos.map(({ id, nome, emoji }) => (
                        <div key={id} className="form-check form-check-inline">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id={`servico-${id}`}
                            checked={form.servicosIds.includes(id)}
                            onChange={() => handleCheckboxChange(id)}
                          />
                          <label htmlFor={`servico-${id}`} className="form-check-label">
                            {emoji ? `${emoji} ` : ""}{nome}
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="col-12">
                    <button
                      type="button"
                      className="btn btn-primary w-100"
                      onClick={() => setStep(4)}
                    >
                      Continue to Contract
                    </button>
                  </div>
                </div>
              )}

              {step === 4 && (
                <div>
                  <div className="mb-3">
                    <h5>{t("companyRegisterModal.contractTitle")}</h5>
                    <div className="border p-3" style={{ maxHeight: 300, overflowY: "scroll" }}>
                      {/* Aqui você pode exibir o PDF ou texto do contrato */}
                      <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. teste
                      </p>
                    </div>
                  </div>
                  <div className="form-check mb-3">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="aceitarContrato"
                      checked={aceitouContrato}
                      onChange={() => setAceitouContrato(!aceitouContrato)}
                    />
                    <label className="form-check-label" htmlFor="aceitarContrato">
                      {t("companyRegisterModal.acceptContract")}
                    </label>
                  </div>
                  <button
                    type="button"
                    className="btn btn-primary w-100"
                    disabled={!aceitouContrato}
                    onClick={handleFinalSubmit}
                  >
                    {t("companyRegisterModal.finishRegistration")}
                  </button>
                </div>
              )}

              {message && <div className="alert alert-success mt-3">{t(`companyRegisterModal.messages.${message}`)}</div>}
              {error && <div className="alert alert-danger mt-3">{t(`companyRegisterModal.errors.${error}`)}</div>}

            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyRegisterModal;